/** @jsxImportSource @emotion/react */
import { forwardRef } from 'react';

import { LoadingLocation, SpinningBadge } from '../Icons';
import Text from '../Text';
import useStyles from './styles';

const Loader = forwardRef(
  ({ message, inline, isOnboarding, isFilter = false, ...rest }, ref) => {
    const styles = useStyles();

    const labelId = 'spinning-loader-text';

    //isOnboarding is to display ef spinning logo at the end of onboarding
    return (
      <div css={styles.loader(inline, 'spinning-loader', isFilter)} {...rest}>
        {isOnboarding === 'false' ? (
          <LoadingLocation />
        ) : (
          <SpinningBadge
            aria-labelledby={labelId}
            animationId="spinning-loader"
          />
        )}
        <Text
          role="text"
          size={6}
          id={labelId}
          css={styles.text(!!message, inline)}
          tabIndex={-1}
          ref={ref}
        >
          {message || 'Loading'}
        </Text>
      </div>
    );
  }
);

export default Loader;
